import { useProjectParams } from '@hooks/useProjectParams';
import { useProjectData } from 'hooks/useProjectData';
import { ContractStructureLayout } from 'pages/Project/Common/Contract/ContractStructure/ContractStructureLayout';
import { methodologyMapReverse } from 'types/methodology';

import type React from 'react';

import { useGetUerContractStructureDataSource } from './hooks/useGetUerContractStructureDataSource';

export const UerContractStructure: React.FC = () => {
    const { id: projectId, methodology } = useProjectParams();
    const { projectData } = useProjectData(projectId);

    return (
        <ContractStructureLayout
            methodology={methodologyMapReverse[methodology as string]}
            projectData={projectData}
            useGetContractStructureDataSource={useGetUerContractStructureDataSource}
        />
    );
};

UerContractStructure.displayName = 'UerContractStructure';
